import axios from 'axios'
import './vue/init'
import './css/main.css'
window.$axios = axios;
